export enum AnalyticsEvent {
  APPLICATION_OPENED = 'Application Opened',
  LOGIN_STARTED = 'Login Started',
  LOGIN_SUCCESSFUL = 'Login Successful',
  LOGIN_FAILED = 'Login Failed',

  GAME_PAGE_OPEN = 'Game Page Open',
  HOME_BUTTON_CLICKED = 'Home button clicked',

  INSTANT_HAMBURGER_OPENED = 'Instant Games Hamburger clicked',
  INSTANT_HAMBURGER_CLOSED = 'Instant Games Hamburger closed',

  SOUND_TOGGLED = 'Sound enabled/disabled',
  MUSIC_TOGGLED = 'Music enabled/disabled',

  RULES_BUTTON_CLICKED = 'Rules button clicked',
  RULES_CLOSED = 'Rules closed clicked',

  HISTORY_BUTTON_CLICKED = 'History button clicked',
  HISTORY_CLOSED = 'History closed',
  HISTORY_SCROLLED = 'History scrolled',

  ROUND_ID_COPY_CLICKED = 'Round id Copy button clicked',

  WINNING_RESULT = 'Winning result',

  INSTANT_STAKE_INCREASE = 'Instant Games: Stake button increase',
  INSTANT_STAKE_DECREASE = 'Instant Games: Stake button decrease',
  INSTANT_STAKE_EDIT_CLICKED = 'Instant Games: <Edit> button clicked',
  INSTANT_STAKE_RESET_CLICKED = 'Instant Games: <Reset> button clicked',
  INSTANT_STAKE_APPLY_CLICKED = 'Instant Games: <Apply> button clicked',
  INSTANT_STAKE_CANCEL_CLICKED = 'Instant Games: <Cancel> button clicked',

  INSTANT_BET_CLICKED = 'Instant Games: <Bet> button clicked',
  INSTANT_CANCEL_BET_CLICKED = 'Instant Games: <Cancel bet> button clicked',

  INSTANT_CASHOUT_CLICKED = 'Instant Games: <Cashout> button clicked',
  INSTANT_CASHOUT_SUCCESS = 'Instant Games: Cashout success',
  INSTANT_CASHOUT_FAILED = 'Instant Games: Cashout failed',
  INSTANT_CASHOUT_TIMEOUT = 'Instant Games: Cashout ACK timeout',

  INSTANT_GAME_LIMITS_OPENED = 'Instant Games: Game Limits tab open',
  INSTANT_GAME_LIMITS_GOT_IT = 'Instant Games: Game Limits <Got It!> button clicked',
  INSTANT_GAME_LIMITS_CANCEL = 'Instant Games: Game Limits <Cancel> button clicked',

  INSTANT_GAME_RULES_OPENED = 'Instant Games: Game Rules Tab tab open',
  INSTANT_GAME_RULES_GOT_IT = 'Instant Games: Game Rules <Got It!> button clicked',
  INSTANT_GAME_RULES_CANCEL = 'Instant Games: Game Rules <Cancel> button clicked',
}
